import keyBy from "lodash.keyby";
import {
  FETCH_BLOG_POSTS,
  FETCH_BLOG_POSTS_SUCCESS,
  FETCH_BLOG_POSTS_FAILED,
  FETCH_PUBLIC_BLOG_POSTS,
  FETCH_PUBLIC_BLOG_POSTS_SUCCESS,
  FETCH_PUBLIC_BLOG_POSTS_FAILED,
  FETCH_BLOG_POST,
  FETCH_BLOG_POST_SUCCESS,
  FETCH_BLOG_POST_FAILED,
  EDIT_BLOG_POST,
  EDIT_BLOG_POST_SUCCESS,
  EDIT_BLOG_POST_FAILED,
  DELETE_BLOG_POST,
  DELETE_BLOG_POST_SUCCESS,
  DELETE_BLOG_POST_FAILED,
  ADD_BLOG_POST,
  ADD_BLOG_POST_SUCCESS,
  ADD_BLOG_POST_FAILED
} from "./constants";

const initialState = {
  posts: [],
  currentPost: {
    title: "",
    author: "",
    highlightText: "",
    coverImage: "",
    bodyHtml: "",
    highlightHtml: ""
  },
  publicPosts: {},
  loading: true
};

function sortByDate(posts) {
  return posts.sort(function(a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b.createTime) - new Date(a.createTime);
  });
}

export default function blogPosts(state = initialState, action) {
  switch (action.type) {
    case FETCH_BLOG_POST:
    case FETCH_BLOG_POSTS:
      return {
        ...state,
        loading: true
      };
    case FETCH_BLOG_POSTS_SUCCESS:
      return {
        ...state,
        posts: sortByDate(action.payload.data),
        loading: false
      };
    case FETCH_BLOG_POST_FAILED:
    case FETCH_BLOG_POSTS_FAILED:
      return {
        ...state,
        error: true,
        errorMessage: action.payload.message,
        loading: false
      };
    case FETCH_BLOG_POST_SUCCESS:
      return {
        ...state,
        currentPost: {
          ...state.currentPost,
          ...action.payload.data
        },
        loading: false
      };
    case EDIT_BLOG_POST:
      return {
        ...state,
        updatingPost: true
      };
    case EDIT_BLOG_POST_SUCCESS:
      return {
        ...state,
        updatingPost: false,
        errorUpdating: false
      };
    case EDIT_BLOG_POST_FAILED:
      return {
        ...state,
        updatingPost: false,
        errorUpdating: true,
        errorMessage: action.payload.message
      };

    case DELETE_BLOG_POST:
      return {
        ...state,
        deletingPost: true
      };
    case DELETE_BLOG_POST_SUCCESS:
      return {
        ...state,
        deletingPost: false,
        errorDeleting: false
      };
    case DELETE_BLOG_POST_FAILED:
      return {
        ...state,
        deletingPost: false,
        errorDeleting: true,
        errorMessage: action.payload.message
      };

    case ADD_BLOG_POST:
      return {
        ...state,
        addingPost: true
      };
    case ADD_BLOG_POST_SUCCESS:
      return {
        ...state,
        addingPost: false,
        errorAdding: false
      };
    case ADD_BLOG_POST_FAILED:
      return {
        ...state,
        addingPost: false,
        errorAdding: true,
        errorMessage: action.payload.message
      };

    case FETCH_PUBLIC_BLOG_POSTS:
      return {
        ...state,
        loading: true
      };
    case FETCH_PUBLIC_BLOG_POSTS_SUCCESS:
      return {
        ...state,
        publicPosts: keyBy(action.payload.data, "id"),
        loading: false
      };
    case FETCH_PUBLIC_BLOG_POSTS_FAILED:
      return {
        ...state,
        error: true,
        errorMessage: action.payload.message,
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/blog/reducer.js